<template>
  <div class="postDropdown">
    <div class="container">
      <div class="option" v-if="type == 'excluded'" @click="unexclude">
        <span class="text">Cancel break</span>
      </div>
      <div class="option" v-if="type == 'excluded'" @click="editExclusion">
        <span class="text">Edit break</span>
      </div>
      <div class="option" v-if="type == 'excluded'" @click="block">
        <span class="text">Block</span>
      </div>
      <div class="option" v-if="type == 'blocked'" @click="unblock">
        <span class="text">Unblock</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyOptions",
  props: {
    type: String,
  },
  methods: {
    async unexclude() {
      this.$emit("unexclude");
    },
    async editExclusion() {
      this.$emit("editExclusion");
    },
    async unblock() {
      this.$emit("unblock");
    },
    async block() {
      this.$emit("block");
    },
  },
};
</script>

<style scoped>
/* **************** PostOptions.vue ****************** */
.postDropdown {
  position: absolute;
  width: 200px;
  top: 60px;
  right: 15px;
  border-radius: 16px;
  transition: 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  cursor: default;
  box-sizing: border-box;
  background-color: #ffffff;
  z-index: 9999;
  overflow: hidden;
  padding: 5px;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.postDropdown .container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.postDropdown .option {
  margin: 0 auto;
  width: 100%;
  padding: 8px 12px;
  font-size: 15px;
  cursor: pointer;
  word-break: break-word;
  position: relative;
  border-radius: 16px;
  text-align: center;
  justify-content: flex-start;
  display: flex;
  margin-bottom: 2px;
  box-sizing: border-box;
}

.postDropdown .option:last-of-type {
  margin-bottom: 0px;
}

.postDropdown .option:hover {
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(255 255 255 / 80%);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.postDropdown .option .text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  font-weight: 500;
  color: #333;
  text-align: left;
}
</style>
